import React, { useEffect, useState } from "react";
//import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";

import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { useRecoilValue, useRecoilState } from "recoil";
import { PERMISSIONS } from "../../../PermissionsConstants";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useGetProducerByOfficeCode } from "../hooks/useGetProducerByOfficeCode";
import MaterialExTable from "../../../../components/tables/MaterialExTable";
import {
  BuildingLibraryIcon,
  RectangleStackIcon,
  QrCodeIcon,
} from "@heroicons/react/24/solid";
import { mainSelectedTab } from "../../atoms";
import { CarrierAgreementMgmtTabs } from "../../carrierAgreementTabs";
import {
  carrierProdCodeModal,
  CarrierProdCodeOfficeCode,
  prodCodeToOfficeId,
} from "../atoms/atoms";
import { OfficeCarrierProdCodeModal } from "../modals/OfficeCarrierProducerCodeModal";
import OfficeCarrierProducerCodeViewAll from "./OfficeCarrierProducerCodeViewAll";
import TextInputHookForm from "../../../../components/TextInputHookForm";
import { searchDataProducerCode } from "../../ProducerCode/atom";
import SearchInput2 from "../../../../components/SearchInput2";
import { notificationFilterById } from "../../../../actions/Utilities/NotificationFilter";
import { prodCodeId } from "../../../CarrierAgreementMgmt/ProducerCode/atom";
const OfficeCarrierProducerCodeView = ({ data }) => {
  const headerStyle = {
    backgroundColor: "#fff",
    color: "#6495ED",
    fontWeight: "bold",
    fontSize: "13px",
  };
  const history = useHistory();
  const userPermissions = useRecoilValue(permissionsSelector);
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);

  // const handleTabClick = () => {
  //   const url = "/carrieragreementmgmt/producercodeconfig";
  //   history.push({
  //     pathname: `/carrieragreementmgmt/producercodeconfig?actionFrom=CarrierProducerCode&masterCarrierId=${x.masterCarrierID}&carrierProducerCodeId=${x.carrierProducerCodeId}`,
  //   });
  // };

  const {
    mutate: getProducer,
    data: prodData,
    isLoading: prodLoading,
  } = useGetProducerByOfficeCode();
  const editPermission =
    PERMISSIONS.permission_carrieragreemnentmgmt_producercode_edit;
  useEffect(() => {
    if (data.officeCode) {
      getProducer(data?.officeCode);
    }
  }, [data?.officeCode, getProducer]);

  const handleClick = (rowDetails) => {
    history.push({
      pathname: "/carrieragreementmgmt/producercodeconfig",
      state: {
        recordId: rowDetails.carrierProducerCodeId.toString(),
        moduleName: "Producer Code",
        subModuleName: "ProdEdit",
      },
    });
    window.location.reload();
  };

  const [, setSelectedIndex] = useRecoilState(mainSelectedTab);
  const [carrierProdCodeId, setProdCodeId] = useRecoilState(prodCodeId);

  const [, setCarrierProdcodeOfficeCode] = useRecoilState(
    CarrierProdCodeOfficeCode
  );

  const [ofcCarrierProdCodeSeeMore, setOfcCarrierProdCodeSeeMore] =
    useState(false);

  const onClickSeeMore = () => {
    setCarrierProdcodeOfficeCode(data?.officeCode);
    setOfcCarrierProdCodeSeeMore(true);
  };
  const closeSeeMoreModal = () => {
    setOfcCarrierProdCodeSeeMore(false);
  };

  // for Search filter
  const [isSearchTextProdCode, setIsSearchTextProdCode] = useState(false);
  const [filteredCarrierProdCode, setCarrierfilteredCarrierProdCode] = useState(
    []
  );
  const [searchInputField, setSearchInputField] = useState("");
  const [tab, setTab] = useState(0);
  const [getProdCodeToOfficeId, setProdCodeToOfficeId] =
    useRecoilState(prodCodeToOfficeId);

  // for clear button
  const handleClearButton = () => {
    setCarrierProdcodeOfficeCode([]);
    setIsSearchTextProdCode(false);
    handleSearchProdCode("");
    setSearchInputField("");
  };

  const handleSearchProdCode = (target) => {
    setCarrierfilteredCarrierProdCode(
      prodData?.filter(
        (pD) =>
          pD.carrierName
            .toString()
            .toLocaleLowerCase()
            .includes(target.toLocaleLowerCase().toString()) ||
          pD.producerCode
            .toString()
            .toLocaleLowerCase()
            .includes(target.toLocaleLowerCase().toString())
      )
    );
  };

  return (
    <>
      <div className="w-full borderContainer p-2 bg-white px-9">
        {prodData?.length > 5 && (
          <div className="py-2 grid grid-cols-6 gap-1">
            <div className="text-xs col-start-1 col-end-2 flex flex-row">
              <SearchInput2
                className="border-b"
                placeholder="Search "
                id="searchFilter"
                value={searchInputField}
                onChange={(e) => {
                  setSearchInputField(e.target.value);
                  handleSearchProdCode(e.target.value);
                  e.target.value === ""
                    ? setIsSearchTextProdCode(false)
                    : setIsSearchTextProdCode(true);
                }}
              />
              <button
                className="opacity-50 -ml-3 "
                onClick={() => handleClearButton()}
              >
                <label className="-mr-4"> X</label>
              </button>
            </div>
            <button
              onClick={() => onClickSeeMore()}
              className="text-primary text-right underline font-semibold col-end-7 col-span-1"
            >
              See more
            </button>
          </div>
        )}
        <div className="grid gap-2 grid-cols-5">
          {prodData &&
            // prodData?.length > 5 &&
            !isSearchTextProdCode &&
            prodData?.map((x, i) => {
              const producerCode = x.producerCode ? x.producerCode : null;
              const mAproducerCode = x.mAproducerCode ? x.mAproducerCode : null;
              const codes = producerCode ?? mAproducerCode ?? "";
              return (
                i <= 4 && (
                  <div className="bg-white border border-gray-200 w-full shadow-md rounded-md">
                    <div className="flex p-2">
                      <div className="translate-y-4">
                        <QrCodeIcon className="text-blue-500 h-8 w-8" />
                      </div>
                      <div className="text-gray-600 font-medium ml-2 truncate ">
                        <h3 className="text-xs1 flex items-center font-medium text-gray-400">
                          <svg
                            className={
                              x.isActive
                                ? "text-green-500 mr-1 talic h-2 w-2"
                                : "text-gray-40 mr-1 talic h-2 w-2"
                            }
                            fill="currentColor"
                            viewBox="0 0 8 8"
                          >
                            <circle cx={4} cy={4} r={3} />
                          </svg>{" "}
                          {x.isActive ? "Active" : "Inactive"}
                        </h3>
                        <h1
                          className="tileClasses"
                          onClick={() => {
                            const url =
                              "/carrieragreementmgmt/producercodeconfig";
                            history.push({
                              pathname: url,
                              state: {
                                masterCarrierId: x.masterCarrierID,
                                carrierProducerCodeId: x.carrierProducerCodeId,
                                action: "CarrierProducerCode",
                                officeId: getProdCodeToOfficeId,
                              },
                            });

                            window.location.reload();
                          }}
                        >
                          {codes}
                        </h1>
                        {!x.producerCode && (
                          <h2 className="text-xxs font-medium text-gray-400">
                            {"MA Codes"}
                          </h2>
                        )}

                        <h2 className="text-xs font-medium text-gray-700 mt-1">
                          {x.carrierName ? x.carrierName : "unspecified"}
                        </h2>
                        <h2 className="text-xxs font-medium text-gray-400">
                          {x.associatedTo ? x.associatedTo : "unspecified"}
                        </h2>
                      </div>
                    </div>
                  </div>
                )
              );
            })}
          {isSearchTextProdCode &&
            filteredCarrierProdCode?.map((x, i) => {
              const producerCode = x.producerCode ? x.producerCode : null;
              const mAproducerCode = x.mAproducerCode ? x.mAproducerCode : null;
              const codes = producerCode ?? mAproducerCode ?? "";
              return (
                i <= 4 && (
                  <div className="bg-white border border-gray-200 w-full shadow-md rounded-md">
                    <div className="flex p-2">
                      <div className="translate-y-4">
                        <QrCodeIcon className="text-blue-500 h-8 w-8" />
                      </div>
                      <div className="text-gray-600  ml-2 truncate ">
                        <h3 className="text-xs1 flex items-center font-normal text-gray-400">
                          <svg
                            className={
                              x.isActive
                                ? "text-green-500 mr-1 talic h-2 w-2"
                                : "text-gray-40 mr-1 talic h-2 w-2"
                            }
                            fill="currentColor"
                            viewBox="0 0 8 8"
                          >
                            <circle cx={4} cy={4} r={3} />
                          </svg>{" "}
                          {x.isActive ? "Active" : "Inactive"}
                        </h3>

                        <h1
                          className="tileClasses"
                          onClick={() => {
                            const url =
                              "/carrieragreementmgmt/producercodeconfig";
                            history.push({
                              pathname: url,
                              state: {
                                masterCarrierId: x.masterCarrierID,
                                carrierProducerCodeId: x.carrierProducerCodeId,
                                action: "CarrierProducerCode",
                                officeId: getProdCodeToOfficeId,
                              },
                            });

                            window.location.reload();
                          }}
                        >
                          {codes}
                        </h1>
                        {!x.producerCode && (
                          <h2 className="text-xxs font-medium text-gray-400">
                            {"MA Codes"}
                          </h2>
                        )}
                        <h2 className="text-xs font-medium text-gray-700 mt-1">
                          {x.carrierName ? x.carrierName : "unspecified"}
                        </h2>
                        <h2 className="text-xxs font-medium text-gray-400">
                          {x.associatedTo ? x.associatedTo : "unspecified"}
                        </h2>
                      </div>
                    </div>
                  </div>
                )
              );
            })}
          {isSearchTextProdCode && filteredCarrierProdCode.length === 0 && (
            <div className="flex pt-2 pb-5 items-center justify-center text-sm col-span-5">
              No records to display
            </div>
          )}
        </div>
      </div>
      {ofcCarrierProdCodeSeeMore && (
        <OfficeCarrierProdCodeModal
          showFullView={ofcCarrierProdCodeSeeMore}
          closeFullView={closeSeeMoreModal}
          officeCode={data?.officeCode}
        >
          <OfficeCarrierProducerCodeViewAll
            data={
              prodData
                ? prodData?.map((data) => ({
                    ...data,
                  }))
                : filteredCarrierProdCode && filteredCarrierProdCode
            }
          />
        </OfficeCarrierProdCodeModal>
      )}
    </>
  );
};
export default OfficeCarrierProducerCodeView;
